import request from '../utils/request'
import global from '../config/global'

function list(project_id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_ACCESS_KEYS.replace(':id', project_id),
    method: 'get',
    params
  })
}

function create(project_id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_ACCESS_KEYS.replace(':id', project_id),
    method: 'post',
    data
  })
}

function update(project_id, id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_ACCESS_KEY.replace(':id', project_id).replace(':access_key_id', id),
    method: 'put',
    data
  })
}

function activate(project_id, id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_ACCESS_KEY_ACTIVATED.replace(':id', project_id).replace(':access_key_id', id),
    method: 'put',
    data
  })
}

function rotate(project_id, id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_ACCESS_KEY_ROTATE_KEY.replace(':id', project_id).replace(':access_key_id', id),
    method: 'put',
    data
  })
}

function remove(project_id, id) {
  return request({
    url: global.endpoint.PROJECT_ACCESS_KEY.replace(':id', project_id).replace(':access_key_id', id),
    method: 'delete',
  })
}

export default {
  list,
  create,
  update,
  activate,
  rotate,
  remove
}
